import React from 'react';
import { CheckCircle, AlertCircle, X } from 'lucide-react';
import type { SupportNotificationMessage } from './supportTypes';

interface SupportNotificationModalProps {
  message: SupportNotificationMessage;
  onClose: () => void;
}

export const SupportNotificationModal: React.FC<SupportNotificationModalProps> = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <div className={`bg-slate-900/95 border rounded-xl shadow-2xl w-full max-w-md p-6 ${
        message.type === 'success' ? 'border-green-500/30' : 'border-red-500/30'
      }`}>
        <div className="flex items-start space-x-4">
          <div className={`flex-shrink-0 p-2 rounded-lg ${
            message.type === 'success' ? 'bg-green-500/20' : 'bg-red-500/20'
          }`}>
            {message.type === 'success' ? (
              <CheckCircle className="w-6 h-6 text-green-400" />
            ) : (
              <AlertCircle className="w-6 h-6 text-red-400" />
            )}
          </div>
          <div className="flex-1">
            <h3 className={`text-lg font-semibold mb-1 ${
              message.type === 'success' ? 'text-green-400' : 'text-red-400'
            }`}>
              {message.type === 'success' ? 'Success' : 'Error'}
            </h3>
            <p className="text-sm text-gray-300">{message.text}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors flex-shrink-0"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
